import { ButtonTypes } from '@kaltura-ott/tvpil';

export default function findLoginItems(items: { inAppLink: string; title: string; type: string }[]) {
  const signIn = items && items.slice().find((item) => item.type === ButtonTypes.login);
  const signUp = items && items.slice().find((item) => item.type === ButtonTypes.sign_up);

  return { signIn, signUp };
}
